import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { invoiceDueDateFilterConfig } from '../../../configs/invoice-due-date-filter-config';

export const InvoiceDueDateFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Due Date'
      config={invoiceDueDateFilterConfig}
    />
  );
};
